import * as React from 'react';
import MagicForm from '../../../Components/Form/MagicForm';
import useWizardTree from '../../../Hooks/useWizardTree';
import { useState } from 'react';
import { useEffectAsync } from '../../../helpers';
import Loading from '../../../Components/Loading';

interface HealthPlanUserInitQuestionnaireFormProps {
	onSubmit: (values: any) => void;
	userId: string;
	readOnly?: boolean;
}

const HealthPlanUserInitQuestionnaireForm: React.FC<
	HealthPlanUserInitQuestionnaireFormProps
> = props => {
	const { onSubmit, userId, readOnly } = props;

	const [scheme, setScheme] = useState([]);
	const [defaultValues, setDefaultValues] = useState(null);
	const [isInitialized, setIsInitialized] = useState(false);

	const { getWizard } = useWizardTree({
		wizardKey: 'health-plan-patient-questionnaire',
		params: {
			userId,
		},
	});

	useEffectAsync(async () => {
		const wizard = await getWizard();

		setScheme(wizard?.children || []);
		setDefaultValues(wizard?.settings?.defaultValues || null);
		setIsInitialized(true);
	}, []);

	if (!isInitialized) return <Loading />;

	return (
		<MagicForm
			formScheme={scheme}
			defaultValues={defaultValues}
			onSubmit={onSubmit}
			readOnly={readOnly}
		/>
	);
};

export default HealthPlanUserInitQuestionnaireForm;
